import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import api from "../../api/axiosInstance";
import { AccountListProps, PaginationProps } from "../../typings";
import AccountsList from "./AccountList";
import AccountsScreenHeader from "./AccountScreenHeader";
import { PAGINATION_VALUES } from "../../data/pagination";

const Accounts = () => {
  const [accounts, setAccounts] = useState<AccountListProps[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");
  const [pagination, setPagination] =
    useState<PaginationProps>(PAGINATION_VALUES);

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const response = await api.get("/accounts", {
          params: {
            page_no: pagination.page_number,
            page_size: pagination.page_size,
          },
        });

        setAccounts(response.data.data);
        setPagination(response.data.pagination);
      } catch (error: any) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAccounts();
  }, [pagination.page_number, pagination.page_size]);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPagination((p) => ({ ...p, page_number: newPage + 1 })); // MUI is 0-based
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPagination({
      page_number: 1,
      page_size: parseInt(event.target.value, 10),
      total_no_of_records: pagination.total_no_of_records,
      total_no_of_pages: pagination.total_no_of_pages,
    });
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <AccountsScreenHeader />
      <AccountsList
        accounts={accounts}
        pagination={pagination}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
};

export default Accounts;
